module.exports = __webpack_public_path__ + "static/media/group1.935e8be3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group1.svg
// module id = 1354
// module chunks = 0